export default __webpack_public_path__ + "73406a2393a10ea5f557c89862b00efb.png";